import React, { useContext, useState } from "react";
import { QK } from "../../../base/qk";
import { useQuery } from "react-query";
import { getHealthAssesments } from "../../../api/services/notification";
import TableComponent from "../../TableComponent/TableComponent";
import { formatDateTime } from "../../../base/FormatTime";
import MyContext from "../../../context/MyContext";

const TempChartContent = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const assessmentType = "temperature";
  const { locationID } = useContext(MyContext);

  const assessmentsPerPage = 10;

  const { data: assessments, isLoading } = useQuery(
    [QK.tempLists, currentPage, assessmentType, locationID],
    () => getHealthAssesments(currentPage, assessmentType, locationID),
    { keepPreviousData: true, enabled: !!currentPage || !!locationID }
  );

  const totalRecords = assessments?.count || 0;
  const totalPages = Math.ceil(totalRecords / assessmentsPerPage);

  const handlePageChange = (event, page) => setCurrentPage(page);

  const columns = [
    {
      field: "client_name",
      headerName: "Client Name",
    },
    {
      field: "date_time",
      headerName: "Date / Time",
      render: (value) => formatDateTime(value),
    },
    { field: "value", headerName: "Temperature (celcius)" },
    { field: "notes", headerName: "Notes" },
  ];

  return (
    <div>
      <TableComponent
        columns={columns}
        data={assessments?.results || []}
        isLoading={isLoading}
        pagination={{ totalPages, currentPage }}
        onPageChange={handlePageChange}
        size="medium"
      />
    </div>
  );
};

export default TempChartContent;
